import {
	House,
	FileText,
	Layers3,
	Users,
	GraduationCap,
	LayoutDashboard,
	ClipboardCheck,
	FileCheck2,
	ShieldCheck,
	UserRound,
	Settings,
	SlidersHorizontal,
	LogOut,
	LogIn,
	PanelLeftOpen,
	PanelLeftClose,
	ChevronRight,
	ChevronUp,
	ChartColumnBig,
	Menu,
	X,
	ArrowLeft,
	Download,
	Printer,
	Pencil,
} from 'lucide-react';
import type { LayoutIconName } from './types';

interface LayoutIconProps {
	name: LayoutIconName;
	className?: string;
	size?: number | string;
	strokeWidth?: number;
}

const ICON_MAP = {
	home: House,
	file: FileText,
	layers: Layers3,
	users: Users,
	'graduation-cap': GraduationCap,
	dashboard: LayoutDashboard,
	chart: ChartColumnBig,
	'clipboard-check': ClipboardCheck,
	'file-check': FileCheck2,
	'shield-check': ShieldCheck,
	'user-round': UserRound,
	settings: Settings,
	'sliders-horizontal': SlidersHorizontal,
	'log-out': LogOut,
	'log-in': LogIn,
	'panel-left-open': PanelLeftOpen,
	'panel-left-close': PanelLeftClose,
	'chevron-right': ChevronRight,
	'chevron-up': ChevronUp,
	'arrow-left': ArrowLeft,
	download: Download,
	printer: Printer,
	pencil: Pencil,
	menu: Menu,
	x: X,
} as const;

export function LayoutIcon({ name, className, size, strokeWidth = 1.8 }: LayoutIconProps) {
	const Icon = ICON_MAP[name] || House;
	return <Icon className={className} size={size} strokeWidth={strokeWidth} />;
}
